var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.264,0.352 C14.984,0.552 15.448,1.016 15.648,1.736 C15.752,2.112 15.824,2.616 15.872,3.256 C15.928,3.896 15.952,4.448 15.952,4.928 L16,5.6 C16,7.352 15.872,8.64 15.648,9.464 C15.448,10.184 14.984,10.648 14.264,10.848 C13.888,10.952 13.2,11.024 12.144,11.072 C11.104,11.128 10.152,11.152 9.272,11.152 L8,11.2 C4.648,11.2 2.56,11.072 1.736,10.848 C1.016,10.648 0.552,10.184 0.352,9.464 C0.248,9.088 0.176,8.584 0.128,7.944 C0.072,7.304 0.048,6.752 0.048,6.272 L0,5.6 C0,3.848 0.128,2.56 0.352,1.736 C0.552,1.016 1.016,0.552 1.736,0.352 C2.112,0.248 2.8,0.176 3.856,0.128 C4.896,0.072 5.848,0.048 6.728,0.048 L8,2.7533531e-14 C11.352,2.7533531e-14 13.44,0.128 14.264,0.352 Z M6.4,3.2 L6.4,8 L10.552,5.6 L6.4,3.2 Z",
    id: "icon-youtube",
    fill: "#FF0000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.922d651c25fa790884766b7957249f20.svg";
export { ForwardRef as ReactComponent };